/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_ChildTool = (function(superclass) {

    const $ = {

    };

	class B_ChildTool extends superclass {

		constructor(obj) {
		    super(obj);

			if(typeof this.CODMOS.TOOL != 'undefined') this.CODMOS.TOOL[this._id] = this;

			/*[T]*/ B_Util.print(B_Define.MESSAGE['CREATE_TOOL_OBJECT'] + ' ( id: ' + this._id + ' )');
		}

	}

	return B_ChildTool;
});

export default B_ChildTool;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/base/B_ChildTool.js